import * as React from 'react';

const GooglePayPaymentRebrandingSvg = (
    props: React.SVGProps<SVGSVGElement>,
) => (
    <svg width={36} height={32} viewBox="0 0 192 128" fill="none" {...props}>
        <g clipPath="url(#google-pay-payment-rebranding_svg__clip0_101_1024)">
            <path
                d="M0 16C0 7.163 7.163 0 16 0h160c8.837 0 16 7.163 16 16v96c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16V16z"
                fill="#fff"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M176 4H16C9.373 4 4 9.373 4 16v96c0 6.627 5.373 12 12 12h160c6.627 0 12-5.373 12-12V16c0-6.627-5.373-12-12-12zM16 0C7.163 0 0 7.163 0 16v96c0 8.837 7.163 16 16 16h160c8.837 0 16-7.163 16-16V16c0-8.837-7.163-16-16-16H16z"
                fill="#E8E8E7"
            />
            <path
                d="M91.76 78.059h-4.678V41.656h12.403c3.143 0 5.823 1.047 8.016 3.143 2.242 2.095 3.363 4.654 3.363 7.675 0 3.095-1.121 5.653-3.363 7.725-2.168 2.07-4.849 3.094-8.016 3.094H91.76v14.766zm0-31.92v12.695h7.822c1.852 0 3.412-.634 4.63-1.876 1.242-1.243 1.876-2.754 1.876-4.46 0-1.68-.634-3.167-1.876-4.41-1.218-1.291-2.754-1.925-4.63-1.925h-7.821v-.024zM123.095 52.328c3.46 0 6.189.926 8.187 2.778 1.998 1.852 2.997 4.386 2.997 7.602V78.06h-4.459v-3.46h-.195c-1.925 2.85-4.507 4.264-7.724 4.264-2.753 0-5.044-.804-6.895-2.436-1.852-1.633-2.778-3.656-2.778-6.092 0-2.583.974-4.63 2.924-6.14 1.949-1.535 4.556-2.29 7.797-2.29 2.778 0 5.068.51 6.847 1.534v-1.072c0-1.633-.634-2.997-1.925-4.142-1.291-1.145-2.802-1.706-4.532-1.706-2.607 0-4.678 1.097-6.189 3.314l-4.118-2.583c2.266-3.29 5.629-4.922 10.063-4.922zm-6.043 18.08c0 1.218.512 2.242 1.56 3.046 1.023.804 2.241 1.218 3.63 1.218 1.974 0 3.728-.73 5.263-2.193 1.536-1.462 2.315-3.168 2.315-5.141-1.462-1.145-3.484-1.73-6.091-1.73-1.901 0-3.485.463-4.752 1.364-1.291.95-1.925 2.096-1.925 3.436zM159.718 53.133L144.124 89h-4.825l5.799-12.549-10.282-23.318h5.092l7.407 17.884h.098l7.212-17.884h5.093z"
                fill="#3C4043"
            />
            <path
                d="M73.152 60.345c0-1.526-.137-2.985-.39-4.389h-19.61v8.041L64.446 64a9.674 9.674 0 01-4.191 6.476v5.217h6.723c3.925-3.633 6.174-9.003 6.174-15.348z"
                fill="#4285F4"
            />
            <path
                d="M60.257 70.477c-1.871 1.262-4.281 2-7.1 2-5.446 0-10.066-3.67-11.72-8.616h-6.935v5.38C37.938 76.06 45 80.737 53.157 80.737c5.638 0 10.375-1.854 13.823-5.046l-6.723-5.215z"
                fill="#34A853"
            />
            <path
                d="M40.783 59.87c0-1.39.232-2.732.654-3.994v-5.38h-6.935a20.764 20.764 0 00-2.22 9.373c0 3.373.802 6.555 2.22 9.374l6.934-5.38a12.588 12.588 0 01-.653-3.993z"
                fill="#FABB05"
            />
            <path
                d="M53.157 47.26c3.077 0 5.833 1.06 8.009 3.131l5.958-5.953C63.505 41.068 58.788 39 53.157 39c-8.155 0-15.22 4.678-18.655 11.496l6.934 5.38c1.655-4.947 6.275-8.616 11.72-8.616z"
                fill="#E94235"
            />
        </g>
        <defs>
            <clipPath id="google-pay-payment-rebranding_svg__clip0_101_1024">
                <path fill="#fff" d="M0 0h192v128H0z" />
            </clipPath>
        </defs>
    </svg>
);

GooglePayPaymentRebrandingSvg.displayName = 'GooglePayPaymentRebrandingSvg';
export default GooglePayPaymentRebrandingSvg;
